import { render, staticRenderFns } from "./NuevoSueldo.vue?vue&type=template&id=4a34b856&"
import script from "./NuevoSueldo.vue?vue&type=script&lang=js&"
export * from "./NuevoSueldo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports